import reduce from 'lodash/reduce';
export var transformOfferContents = function (offerContents) {
    return offerContents.map(function (item) { return ({
        id: item.id,
        image: item.image,
        image_webp: item.image_webp || item.image,
        width: item.image_width,
        title: item.title,
        type: 'subscription',
        sort: item.sort,
    }); });
};
export var transformSalePackageLinks = function (salePackageLinks) {
    return Object.values(reduce(salePackageLinks, function (acc, spl) {
        if ('subscriptions' in spl && spl.subscriptions) {
            spl.subscriptions.forEach(function (item) {
                acc[item.id] = {
                    id: item.id,
                    image: item.image,
                    image_webp: item.image_webp,
                    width: item.image_width,
                    title: item.title,
                    type: 'subscription',
                    sort: item.sort,
                };
            });
        }
        return acc;
    }, {}))
        .sort(function (a, b) { return a.sort && b.sort ? a.sort - b.sort : -1; });
};
export var transformAdditionalProducts = function (additionalProducts) {
    return additionalProducts === null || additionalProducts === void 0 ? void 0 : additionalProducts.filter(function (_a) {
        var product_type = _a.product_type, required = _a.required;
        return product_type === 'tv' && required;
    }).map(function (_a) {
        var id = _a.id, shopItem = _a.shopItem;
        return ({
            id: id,
            image: (shopItem === null || shopItem === void 0 ? void 0 : shopItem.image_for_tariff_card) || '',
            image_webp: (shopItem === null || shopItem === void 0 ? void 0 : shopItem.image_for_tariff_card_webp) || '',
            width: shopItem === null || shopItem === void 0 ? void 0 : shopItem.image_width,
            title: (shopItem === null || shopItem === void 0 ? void 0 : shopItem.title) || '',
            type: 'equipment',
        });
    });
};
